<agpr-dialog-container
    [id]="id"
    class="previewText"
    [heading]="heading"
    [hideFooter]="true"
    [clickOutside]="true"
    (close)="close()"
>
    <agpr-scroll-panel>
        <agpr-shadow-dom-container
            [customHtml]="content"
        ></agpr-shadow-dom-container>
    </agpr-scroll-panel>
</agpr-dialog-container>
